import React from 'react';
import { renderWithRoot } from '../utilities/reactRoot';
import SubcategoryShowContainer from '../components/pages/SubcategoryShowContainer';

$(() => {
    if (window.folderItems && window.subcategory) {
        window.folderId = window.subcategory.id;
        window.categoryId = window.subcategory.category_id;

        renderWithRoot(
            <SubcategoryShowContainer subcategory={window.subcategory} />,
            document.getElementById('category-show-container'),
        );
    }
});
